// The latest actionable card holds voice auto-send (G5). Identity-bound
// cleanup keeps an older message from clearing its replacement's focus.
import type { VoiceFocus, VoiceFocusCard } from '../contracts';

let card: VoiceFocusCard | null = null;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((listener) => listener());

export const voiceFocus: VoiceFocus = {
  current: () => card,
  register(next) {
    // A newer card owns focus. Cleanup is identity-bound so an old assistant
    // message can never clear a card that replaced it.
    card = next;
    notify();
    return () => {
      if (card === next) {
        card = null;
        notify();
      }
    };
  },
  subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
